import { useCallback, useMemo, useState } from "react";
import { CheckboxList, CheckboxListProps } from "./CheckboxList";
import { ChipsList } from "./ChipsList";
import { Menu } from "@mui/material";

export interface MultiSelectMenuProps<V extends string | number = string>
  extends CheckboxListProps<V> {
  actionLabel?: string;
}

export function MultiSelectMenu<V extends string | number = string>({
  options,
  selected,
  setSelected,
  actionLabel,
}: MultiSelectMenuProps<V>) {
  const handleRemoveItem = useCallback(
    (value: V) => setSelected(selected.filter((item) => item !== value)),
    [selected, setSelected]
  );

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget),
    []
  );

  const handleClose = useCallback(() => setAnchorEl(null), []);

  const selectedOptions = useMemo(
    () => options.filter((option) => selected.includes(option.value)),
    [options, selected]
  );

  return (
    <>
      <ChipsList
        selectedOptions={selectedOptions}
        deselectOption={handleRemoveItem}
        onAddNewOptionClick={handleClick}
        actionLabel={actionLabel}
      />
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <CheckboxList
          options={options}
          selected={selected}
          setSelected={setSelected}
        />
      </Menu>
    </>
  );
}
